
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';
import { ThirdParty } from '../../../models/register/organizational/third-party';

@Injectable()
export class ThirdPartyEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    thirdParty: ThirdParty;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getThirdParty()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getThirdParty(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.thirdParty = data;
                this.onDataChanged.next(this.thirdParty);
                resolve(this.thirdParty);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('thirdParty/' + this.routeParams.id).subscribe({next:(res: ThirdParty ) => {
                    this.thirdParty = res;
                    this.onDataChanged.next(this.thirdParty);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(thirdParty): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('thirdParty/', thirdParty).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    insertThirdPartyOrderItem(orderItemThirdParty): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('orderItemThirdParty/', orderItemThirdParty).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    deleteThirdPartyOrderItem(thirdParty): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('orderItemThirdParty/' + thirdParty.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    edit(thirdParty): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('thirdParty/', thirdParty).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }


    replaceAll(fromThirdPartyId : number, toThirdPartyId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('thirdParty/' + fromThirdPartyId + '/' + toThirdPartyId).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(thirdParty): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('thirdParty/' + thirdParty.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    insertThirdPartyAuthorized(thirdPartyAuthorized): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('thirdPartyAuthorized/', thirdPartyAuthorized).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    deleteThirdPartyAuthorized(thirdPartyAuthorized): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('thirdPartyAuthorized/' + thirdPartyAuthorized.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): ThirdParty {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
